import { useEffect } from 'react'
import { usePostApiV1AccountsPasswordRecoverMutation } from '../../../../../authApi'
import { getServerApiErrorCode, ErrorT } from '@wellesley/error-kit'
import { useDispatch } from 'react-redux'
import { authSlice } from '../../../../../authSlice'
import { fixedCacheKey } from '../../ForgotPasswordRequest/useSubmit'

export const useResendCode = () => {
  const dispatch = useDispatch()
  const { setForgotPasswordStep, resetForgotPasswordFields } = authSlice.actions

  const [resendCode, { error }] = usePostApiV1AccountsPasswordRecoverMutation({
    fixedCacheKey,
  })

  useEffect(() => {
    if (getServerApiErrorCode(error as ErrorT) === 'VerificationCodeTooMany') {
      dispatch(resetForgotPasswordFields())
      dispatch(setForgotPasswordStep('request'))
    }
  }, [error])

  return { resendCode }
}
